import { render } from "./RegistrationError.vue?vue&type=template&id=b6b7f91e&scoped=true"
const script = {}

import "./RegistrationError.vue?vue&type=style&index=0&id=b6b7f91e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b7f91e"]])

export default __exports__